import { useMutation, useQuery } from 'react-query';
import UsersService from '~/api/services/users';
import { onError } from '~/utils/helpers';

const blockUserById = (onSuccess: any) => {
  return useMutation(UsersService.blockUserById, {
    onSuccess,
    onError,
    retry: 1
  });
};

const unblockUserById = (onSuccess: any) => {
  return useMutation(UsersService.unblockUserById, {
    onSuccess,
    onError,
    retry: 1
  });
};

const sendPasswordResetLinkToUserById = (onSuccess: any) => {
  return useMutation(UsersService.sendPasswordResetLinkToUserById, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getUserOptionsData = () => useQuery(
  'get-edit-user-options',
  () => UsersService.getUserOptionsData(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
);

const getEditUser = (onSuccess, id) => useQuery(
  'get-edit-user',
  () => UsersService.getEditUser(id),
  {
    onError,
    onSuccess,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const storeUser = (onSuccess: any) => {
  return useMutation(UsersService.storeUser, {
    onSuccess,
    onError,
    retry: 1
  });
};

const editUser = (onSuccess: any) => {
  return useMutation(UsersService.editUser, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getUsersList = (data) => useQuery(
  'get-users-list',
  () => UsersService.getUserList(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

export const UsersQuery = {
  blockUserById,
  unblockUserById,
  sendPasswordResetLinkToUserById,
  getUserOptionsData,
  getEditUser,
  storeUser,
  editUser,
  getUsersList
}

